import * as React from 'react'
import classNames from 'classnames'
import ActiveIcon from './ActiveIcon'

export interface SwitchProps extends React.ComponentPropsWithoutRef<'div'> {
	items: {
		name: string
		value: string
	}[]
	value: string
	setValue: (value: string) => void
}

const Switch: React.FC<SwitchProps> = ({ items, value, setValue }) => (
	<div className={classNames('flex gap-x-[2px] h-12')}>
		{items.map(item => (
			<button
				key={item.value}
				className={classNames(
					'flex px-5 flex-1 items-center justify-center font-medium relative text-sm tracking-wider first:rounded-l-xl last:rounded-r-xl transition-colors duration-300',
					{
						'bg-brand-primary-light text-brand-primary-md': value === item.value,
						'hover:bg-brand-primary-light bg-white hover:text-brand-primary-md text-brand-gray-200':
							value !== item.value,
					},
				)}
				onClick={() => setValue(item.value)}
				type="button"
			>
				{value === item.value && <ActiveIcon />}
				{item.name}
			</button>
		))}
	</div>
)

Switch.displayName = 'Switch'
export default Switch
